var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('category-form',{model:{value:(_vm.category),callback:function ($$v) {_vm.category=$$v},expression:"category"}})}
var staticRenderFns = []

export { render, staticRenderFns }